var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown',{attrs:{"text":_vm.selectedUserName}},_vm._l((_vm.activeUsers),function(user){return _c('b-dropdown-item',{key:user.id,on:{"click":function($event){return _vm.userSelected(user)}}},[_vm._v(_vm._s(user.firstName)+" "+_vm._s(user.lastName))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }